import { tick } from 'svelte';
let currentPath = getRoutePath();
let lastScrollPosition = 0;
history.scrollRestoration = 'manual';
class ClientRouter {
    init(onRouteChange) {
        const onClick = (e) => {
            const el = e.target;
            const link = el.closest('a[href^="/"]');
            if (!link)
                return;
            const target = link.getAttribute('target');
            if (target && target !== '_self')
                return;
            const url = new URL(link.href);
            e.preventDefault();
            if (url.href !== location.href) {
                ClientRouter.push(url.href);
            }
        };
        const onHistoryChange = async (e) => {
            let tempScroll = window.scrollY;
            window.dispatchEvent(new CustomEvent('beforeRouteChange'));
            if (currentPath !== getRoutePath()) {
                await onRouteChange(location);
                await tick();
            }
            if (!e.isTrusted)
                window.scrollTo({ top: 0 });
            else
                window.scrollTo({ top: lastScrollPosition });
            currentPath = getRoutePath();
            lastScrollPosition = tempScroll;
            window.dispatchEvent(new CustomEvent('afterRouteChange'));
        };
        window.addEventListener('click', onClick);
        window.addEventListener('popstate', onHistoryChange);
    }
    static push(path) {
        history.pushState(null, '', path);
        window.dispatchEvent(new Event('popstate'));
    }
}
export default ClientRouter;
function getRoutePath() {
    return location.pathname + location.search;
}
